export default __webpack_public_path__ + "static/media/vietnam_onshore_wind.af90147e.png";